/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-compatible template kind union.
 */
export enum TCTemplateKind {
    WORKFLOW = 'workflow',
    TENANT_BOOTSTRAP = 'tenant-bootstrap',
    FUNNEL = 'funnel',
    EMPLOYEE = 'employee',
    CUSTOM_FIELDS = 'custom-fields',
}
